import type { Routes } from '@angular/router';

import { UnauthorizedComponent } from './core/unauthorized/unauthorized.component';
import { PrivacyPolicyComponent } from './shared/privacy-policy/privacy-policy.component';
import { TermsAndConditionComponent } from './shared/terms-and-condition/terms-and-condition.component';
import { NotFoundComponent } from './templates/web/not-found/not-found.component';
import { WebLayoutComponent } from './templates/web/web-layout/web-layout.component';

export const ROUTES: Routes = [
  {
    path: '',
    component: WebLayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./templates/web/landing-page/landing-page.component').then(
            (m) => m.LandingPageComponent
          ),
      },
      {
        path: 'our-fleet',
        loadComponent: () =>
          import('./templates/web/our-fleet/our-fleet.component').then((m) => m.OurFleetComponent),
      },
      {
        path: 'contact-us',
        loadComponent: () =>
          import('./templates/web/contact-us/contact-us.component').then(
            (m) => m.ContactUsComponent
          ),
      },
      // {
      //   path: 'chauffeur-service',
      //   loadComponent: () => import('./templates/web/chauffeur-service/chauffeur-service.component').then(m => m.ChauffeurServiceComponent)
      // },
      {
        path: 'long-term-service',
        loadComponent: () =>
          import('./templates/web/long-term-service/long-term-service.component').then(
            (m) => m.LongTermServiceComponent
          ),
      },
      { path: 'terms-and-condition', component: TermsAndConditionComponent },
      { path: 'privacy-policy', component: PrivacyPolicyComponent },
    ],
  },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: '**', component: NotFoundComponent },
];
